import { motion } from "framer-motion";
import { Gem, FlaskConical, BadgeCheck, CalendarClock } from "lucide-react";

const ITEMS = [
  {
    icon: Gem,
    title: "Qualità premium",
    text: "Cura maniacale del dettaglio per un risultato impeccabile su ogni superficie.",
  },
  {
    icon: FlaskConical,
    title: "Prodotti professionali",
    text: "Utilizziamo solo prodotti specifici e sicuri per interni, pelle e tessuti.",
  },
  {
    icon: BadgeCheck,
    title: "Risultati garantiti",
    text: "Finiture come nuovo, con protezione anti-UV e igienizzazione profonda.",
  },
  {
    icon: CalendarClock,
    title: "Prenotazione facile",
    text: "Prenota online in pochi secondi con calcolo del prezzo in tempo reale.",
  },
];

export const WhyUs = () => {
  return (
    <section id="perche-noi" data-testid="why-us-section" className="relative py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#7EC8E3] font-semibold">
            I nostri punti di forza
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mt-3">
            Perché <span className="text-metallic">sceglierci</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                data-testid={`why-us-card-${i + 1}`}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="card-metallic rounded-2xl p-7 text-center"
              >
                <div className="mx-auto w-14 h-14 rounded-2xl bg-gradient-to-br from-[#0D1B4A] to-[#0A1A3A] border border-[#7EC8E3]/40 flex items-center justify-center shadow-[0_0_18px_rgba(126,200,227,0.25)]">
                  <Icon size={26} className="text-[#A0E0FF]" />
                </div>
                <h3 className="mt-5 text-lg font-bold text-slate-100">{it.title}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{it.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
